module.exports = __webpack_public_path__ + "static/media/ic-no-results.2c352e86.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-no-results.svg
// module id = 214
// module chunks = 14